import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { Observable } from 'rxjs';

import { EmployeePrivateDocumentServices } from './employeeprivatedocument.service';
import {
  DOCUMENTED_TRAINING_PAGE_SIZE,
  DocumentedTrainingPage,
  EmployeeApprovalDocument
} from '../models/employeeDocument';

@Injectable()
export class EmployeePrivateDocResolver {
  constructor(private backend: EmployeePrivateDocumentServices) {}

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<EmployeePrivateDocumentServices[]> {
    return this.backend.list(+route.params['eid'], 1);
  }
}

@Injectable()
export class ApprovalDocumentResolver {
  constructor(private backend: EmployeePrivateDocumentServices) {}

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<EmployeeApprovalDocument[]> {
    return this.backend.getApprovalDocuments(
      BaseServices.UserFeatureKey,
      BaseServices.BusinessId,
      BaseServices.PortalId,
      1
    );
  }
}

/**
 * Resolves the first page of the employee's documented-training documents.
 */
@Injectable()
export class DocumentedTrainingResolver {
  constructor(private backend: EmployeePrivateDocumentServices) {}

  resolve(route: ActivatedRouteSnapshot): Observable<DocumentedTrainingPage> {
    return this.backend.getDocumentedTrainingPage(
      +route.params['eid'],
      1,
      DOCUMENTED_TRAINING_PAGE_SIZE
    );
  }
}

@Injectable()
export class MultiDocumentedTrainingResolver {
  constructor(private backend: EmployeePrivateDocumentServices) {}

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<EmployeeApprovalDocument[]> {
    return this.backend.getApprovalDocuments(
      BaseServices.UserFeatureKey,
      BaseServices.BusinessId,
      BaseServices.PortalId,
      2
    );
  }
}
